/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 料金システム用 API
 * PR TIMES 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BadRequestResponse,
    BadRequestResponseFromJSON,
    BadRequestResponseToJSON,
    ConfirmBookingPlanResponse,
    ConfirmBookingPlanResponseFromJSON,
    ConfirmBookingPlanResponseToJSON,
    ConfirmUpdatePlanResponse,
    ConfirmUpdatePlanResponseFromJSON,
    ConfirmUpdatePlanResponseToJSON,
    ExtendApplyingPlanBody,
    ExtendApplyingPlanBodyFromJSON,
    ExtendApplyingPlanBodyToJSON,
    ExtendApplyingPlanSuccessResponse,
    ExtendApplyingPlanSuccessResponseFromJSON,
    ExtendApplyingPlanSuccessResponseToJSON,
    GetApplyingPlanResponse,
    GetApplyingPlanResponseFromJSON,
    GetApplyingPlanResponseToJSON,
    GetApplyingProgramResponse,
    GetApplyingProgramResponseFromJSON,
    GetApplyingProgramResponseToJSON,
    GetBillingInfoResponse,
    GetBillingInfoResponseFromJSON,
    GetBillingInfoResponseToJSON,
    GetBookingPlanResponse,
    GetBookingPlanResponseFromJSON,
    GetBookingPlanResponseToJSON,
    GetInvoiceResponse,
    GetInvoiceResponseFromJSON,
    GetInvoiceResponseToJSON,
    GetPlanChangeApprovalRequest,
    GetPlanChangeApprovalRequestFromJSON,
    GetPlanChangeApprovalRequestToJSON,
    InternalServerErrorResponse,
    InternalServerErrorResponseFromJSON,
    InternalServerErrorResponseToJSON,
    PostBookingPlanBody,
    PostBookingPlanBodyFromJSON,
    PostBookingPlanBodyToJSON,
    PostBookingPlanSuccessResponse,
    PostBookingPlanSuccessResponseFromJSON,
    PostBookingPlanSuccessResponseToJSON,
    PostPlanChangeApprovalRequestApproveBody,
    PostPlanChangeApprovalRequestApproveBodyFromJSON,
    PostPlanChangeApprovalRequestApproveBodyToJSON,
    PostPlanChangeApprovalRequestApproveResponse,
    PostPlanChangeApprovalRequestApproveResponseFromJSON,
    PostPlanChangeApprovalRequestApproveResponseToJSON,
    PostPlanChangeApprovalRequestRejectBody,
    PostPlanChangeApprovalRequestRejectBodyFromJSON,
    PostPlanChangeApprovalRequestRejectBodyToJSON,
    PostPlanChangeApprovalRequestRejectResponse,
    PostPlanChangeApprovalRequestRejectResponseFromJSON,
    PostPlanChangeApprovalRequestRejectResponseToJSON,
    PostUpdatePlanSuccessResponse,
    PostUpdatePlanSuccessResponseFromJSON,
    PostUpdatePlanSuccessResponseToJSON,
    SuccessResponse,
    SuccessResponseFromJSON,
    SuccessResponseToJSON,
    UpdateBillingInfoBody,
    UpdateBillingInfoBodyFromJSON,
    UpdateBillingInfoBodyToJSON,
    UpdateBillingInfoSuccessResponse,
    UpdateBillingInfoSuccessResponseFromJSON,
    UpdateBillingInfoSuccessResponseToJSON,
    UpdatePlanBody,
    UpdatePlanBodyFromJSON,
    UpdatePlanBodyToJSON,
} from '../models';

export interface ConfirmBookingPlanRequest {
    postBookingPlanBody?: PostBookingPlanBody;
}

export interface ConfirmUpdatePlanRequest {
    updatePlanBody?: UpdatePlanBody;
}

export interface ExtendApplyingPlanRequest {
    extendApplyingPlanBody?: ExtendApplyingPlanBody;
}

export interface GetPlanChangeApprovalRequestRequest {
    token: string;
}

export interface PostBookingPlanRequest {
    postBookingPlanBody?: PostBookingPlanBody;
}

export interface PostPlanChangeApprovalRequestAprovedRequest {
    token: string;
    postPlanChangeApprovalRequestApproveBody?: PostPlanChangeApprovalRequestApproveBody;
}

export interface PostPlanChangeApprovalRequestRejectRequest {
    token: string;
    postPlanChangeApprovalRequestRejectBody?: PostPlanChangeApprovalRequestRejectBody;
}

export interface UpdateBillingInfoRequest {
    updateBillingInfoBody?: UpdateBillingInfoBody;
}

export interface UpdatePlanRequest {
    updatePlanBody?: UpdatePlanBody;
}

/**
 * 
 */
export class PriceApi extends runtime.BaseAPI {

    /**
     * 適用中のプランの自動更新をキャンセルする
     * Cancel auto renewable to applying plan
     */
    async cancelAutoRenewableRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<SuccessResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/applying_plan/auto_renewable`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * 適用中のプランの自動更新をキャンセルする
     * Cancel auto renewable to applying plan
     */
    async cancelAutoRenewable(initOverrides?: RequestInit): Promise<SuccessResponse> {
        const response = await this.cancelAutoRenewableRaw(initOverrides);
        return await response.value();
    }

    /**
     * 予約プランをキャンセルする
     * Cancel booking plan for current company user
     */
    async cancelBookingPlanRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<SuccessResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/booking_plan`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * 予約プランをキャンセルする
     * Cancel booking plan for current company user
     */
    async cancelBookingPlan(initOverrides?: RequestInit): Promise<SuccessResponse> {
        const response = await this.cancelBookingPlanRaw(initOverrides);
        return await response.value();
    }

    /**
     * 予約プランの変更を確認する
     * Confirm booking plan for current company user
     */
    async confirmBookingPlanRaw(requestParameters: ConfirmBookingPlanRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ConfirmBookingPlanResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/booking_plan/confirm`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostBookingPlanBodyToJSON(requestParameters.postBookingPlanBody),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConfirmBookingPlanResponseFromJSON(jsonValue));
    }

    /**
     * 予約プランの変更を確認する
     * Confirm booking plan for current company user
     */
    async confirmBookingPlan(requestParameters: ConfirmBookingPlanRequest = {}, initOverrides?: RequestInit): Promise<ConfirmBookingPlanResponse> {
        const response = await this.confirmBookingPlanRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * プランの変更内容を確認する
     * Confirm update plan for current company user
     */
    async confirmUpdatePlanRaw(requestParameters: ConfirmUpdatePlanRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ConfirmUpdatePlanResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/update_plan/confirm`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePlanBodyToJSON(requestParameters.updatePlanBody),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConfirmUpdatePlanResponseFromJSON(jsonValue));
    }

    /**
     * プランの変更内容を確認する
     * Confirm update plan for current company user
     */
    async confirmUpdatePlan(requestParameters: ConfirmUpdatePlanRequest = {}, initOverrides?: RequestInit): Promise<ConfirmUpdatePlanResponse> {
        const response = await this.confirmUpdatePlanRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 適用中のプランを更新（延長）する
     * Extend applying plan for current company user
     */
    async extendApplyingPlanRaw(requestParameters: ExtendApplyingPlanRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ExtendApplyingPlanSuccessResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/applying_plan/extend`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ExtendApplyingPlanBodyToJSON(requestParameters.extendApplyingPlanBody),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExtendApplyingPlanSuccessResponseFromJSON(jsonValue));
    }

    /**
     * 適用中のプランを更新（延長）する
     * Extend applying plan for current company user
     */
    async extendApplyingPlan(requestParameters: ExtendApplyingPlanRequest = {}, initOverrides?: RequestInit): Promise<ExtendApplyingPlanSuccessResponse> {
        const response = await this.extendApplyingPlanRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 現在ログインしている企業ユーザーが適用中のプランを取得する
     * Get applying plan for current company user
     */
    async getApplyingPlanRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetApplyingPlanResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/applying_plan`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetApplyingPlanResponseFromJSON(jsonValue));
    }

    /**
     * 現在ログインしている企業ユーザーが適用中のプランを取得する
     * Get applying plan for current company user
     */
    async getApplyingPlan(initOverrides?: RequestInit): Promise<GetApplyingPlanResponse> {
        const response = await this.getApplyingPlanRaw(initOverrides);
        return await response.value();
    }

    /**
     * 現在ログインしている企業ユーザーに適用されているプログラムを取得する
     * Get applying program for current company user
     */
    async getApplyingProgramRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetApplyingProgramResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/applying_program`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetApplyingProgramResponseFromJSON(jsonValue));
    }

    /**
     * 現在ログインしている企業ユーザーに適用されているプログラムを取得する
     * Get applying program for current company user
     */
    async getApplyingProgram(initOverrides?: RequestInit): Promise<GetApplyingProgramResponse> {
        const response = await this.getApplyingProgramRaw(initOverrides);
        return await response.value();
    }

    /**
     * ログインしている企業ユーザーの請求先情報を取得する
     * Get billing info for current company user
     */
    async getBillingInfoRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetBillingInfoResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/billing_info`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBillingInfoResponseFromJSON(jsonValue));
    }

    /**
     * ログインしている企業ユーザーの請求先情報を取得する
     * Get billing info for current company user
     */
    async getBillingInfo(initOverrides?: RequestInit): Promise<GetBillingInfoResponse> {
        const response = await this.getBillingInfoRaw(initOverrides);
        return await response.value();
    }

    /**
     * ログインしている企業ユーザーの予約プランを取得する
     * Get booking plan for current company user
     */
    async getBookingPlanRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetBookingPlanResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/booking_plan`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBookingPlanResponseFromJSON(jsonValue));
    }

    /**
     * ログインしている企業ユーザーの予約プランを取得する
     * Get booking plan for current company user
     */
    async getBookingPlan(initOverrides?: RequestInit): Promise<GetBookingPlanResponse> {
        const response = await this.getBookingPlanRaw(initOverrides);
        return await response.value();
    }

    /**
     * 前回の締め日から今日までの請求情報を取得する
     * Get invoice by period for current company user
     */
    async getInvoiceByPeriodRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetInvoiceResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/invoice/get_by_period`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetInvoiceResponseFromJSON(jsonValue));
    }

    /**
     * 前回の締め日から今日までの請求情報を取得する
     * Get invoice by period for current company user
     */
    async getInvoiceByPeriod(initOverrides?: RequestInit): Promise<GetInvoiceResponse> {
        const response = await this.getInvoiceByPeriodRaw(initOverrides);
        return await response.value();
    }

    /**
     * プラン変更承認画面からプラン変更承認依頼を取得する
     * Get plan change approval request for company user
     */
    async getPlanChangeApprovalRequestRaw(requestParameters: GetPlanChangeApprovalRequestRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetPlanChangeApprovalRequest>> {
        if (requestParameters.token === null || requestParameters.token === undefined) {
            throw new runtime.RequiredError('token','Required parameter requestParameters.token was null or undefined when calling getPlanChangeApprovalRequest.');
        }

        const queryParameters: any = {};

        if (requestParameters.token !== undefined) {
            queryParameters['token'] = requestParameters.token;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/plan_change_approval_request`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPlanChangeApprovalRequestFromJSON(jsonValue));
    }

    /**
     * プラン変更承認画面からプラン変更承認依頼を取得する
     * Get plan change approval request for company user
     */
    async getPlanChangeApprovalRequest(requestParameters: GetPlanChangeApprovalRequestRequest, initOverrides?: RequestInit): Promise<GetPlanChangeApprovalRequest> {
        const response = await this.getPlanChangeApprovalRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * プランを予約する
     * Post booking plan for current company user
     */
    async postBookingPlanRaw(requestParameters: PostBookingPlanRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PostBookingPlanSuccessResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/booking_plan`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostBookingPlanBodyToJSON(requestParameters.postBookingPlanBody),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostBookingPlanSuccessResponseFromJSON(jsonValue));
    }

    /**
     * プランを予約する
     * Post booking plan for current company user
     */
    async postBookingPlan(requestParameters: PostBookingPlanRequest = {}, initOverrides?: RequestInit): Promise<PostBookingPlanSuccessResponse> {
        const response = await this.postBookingPlanRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * プラン変更承認画面からプラン変更承認依頼を承認する
     * Post plan change approval request approve from company user
     */
    async postPlanChangeApprovalRequestAprovedRaw(requestParameters: PostPlanChangeApprovalRequestAprovedRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PostPlanChangeApprovalRequestApproveResponse>> {
        if (requestParameters.token === null || requestParameters.token === undefined) {
            throw new runtime.RequiredError('token','Required parameter requestParameters.token was null or undefined when calling postPlanChangeApprovalRequestAproved.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/plan_change_approval_request/{token}/approve`.replace(`{${"token"}}`, encodeURIComponent(String(requestParameters.token))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostPlanChangeApprovalRequestApproveBodyToJSON(requestParameters.postPlanChangeApprovalRequestApproveBody),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostPlanChangeApprovalRequestApproveResponseFromJSON(jsonValue));
    }

    /**
     * プラン変更承認画面からプラン変更承認依頼を承認する
     * Post plan change approval request approve from company user
     */
    async postPlanChangeApprovalRequestAproved(requestParameters: PostPlanChangeApprovalRequestAprovedRequest, initOverrides?: RequestInit): Promise<PostPlanChangeApprovalRequestApproveResponse> {
        const response = await this.postPlanChangeApprovalRequestAprovedRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * プラン変更承認画面からプラン変更承認依頼を却下する
     * Post plan change approval request reject from company user
     */
    async postPlanChangeApprovalRequestRejectRaw(requestParameters: PostPlanChangeApprovalRequestRejectRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PostPlanChangeApprovalRequestRejectResponse>> {
        if (requestParameters.token === null || requestParameters.token === undefined) {
            throw new runtime.RequiredError('token','Required parameter requestParameters.token was null or undefined when calling postPlanChangeApprovalRequestReject.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/plan_change_approval_request/{token}/reject`.replace(`{${"token"}}`, encodeURIComponent(String(requestParameters.token))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostPlanChangeApprovalRequestRejectBodyToJSON(requestParameters.postPlanChangeApprovalRequestRejectBody),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostPlanChangeApprovalRequestRejectResponseFromJSON(jsonValue));
    }

    /**
     * プラン変更承認画面からプラン変更承認依頼を却下する
     * Post plan change approval request reject from company user
     */
    async postPlanChangeApprovalRequestReject(requestParameters: PostPlanChangeApprovalRequestRejectRequest, initOverrides?: RequestInit): Promise<PostPlanChangeApprovalRequestRejectResponse> {
        const response = await this.postPlanChangeApprovalRequestRejectRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ログインしている企業ユーザーの請求先情報を更新する
     * Update billing info for current company user
     */
    async updateBillingInfoRaw(requestParameters: UpdateBillingInfoRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<UpdateBillingInfoSuccessResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/billing_info`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateBillingInfoBodyToJSON(requestParameters.updateBillingInfoBody),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateBillingInfoSuccessResponseFromJSON(jsonValue));
    }

    /**
     * ログインしている企業ユーザーの請求先情報を更新する
     * Update billing info for current company user
     */
    async updateBillingInfo(requestParameters: UpdateBillingInfoRequest = {}, initOverrides?: RequestInit): Promise<UpdateBillingInfoSuccessResponse> {
        const response = await this.updateBillingInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 現在ログインしている企業ユーザーの定額制プランへの変更を当日から適用する。 従来のプラン変更は翌日からしか選択できない。フローとしてはプラン変更の予約を行い、バッチ処理によって予約が反映される。
     * Update plan for current company user from today 現在ログインしている企業ユーザーの定額制プランへの変更を当日から適用する
     */
    async updatePlanRaw(requestParameters: UpdatePlanRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PostUpdatePlanSuccessResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/applying_plan`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePlanBodyToJSON(requestParameters.updatePlanBody),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostUpdatePlanSuccessResponseFromJSON(jsonValue));
    }

    /**
     * 現在ログインしている企業ユーザーの定額制プランへの変更を当日から適用する。 従来のプラン変更は翌日からしか選択できない。フローとしてはプラン変更の予約を行い、バッチ処理によって予約が反映される。
     * Update plan for current company user from today 現在ログインしている企業ユーザーの定額制プランへの変更を当日から適用する
     */
    async updatePlan(requestParameters: UpdatePlanRequest = {}, initOverrides?: RequestInit): Promise<PostUpdatePlanSuccessResponse> {
        const response = await this.updatePlanRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
